export const checkProductSlug = (productSlug) => {
  const isAchievable = productSlug === 'achievable';
  const isAmc8 = productSlug === 'amc-8';
  const isAmc10 = productSlug === 'amc-10';
  const isAmc12 = productSlug === 'amc-12';
  const isFinraSeries6 = productSlug === 'finra-series-6';
  const isFinraSeries7 = productSlug === 'finra-series-7';
  const isFinraSeries63 = productSlug === 'finra-series-63';
  const isFinraSeries65 = productSlug === 'finra-series-65';
  const isFinraSeries66 = productSlug === 'finra-series-66';
  const isFinraSie = productSlug === 'finra-sie';
  const isUsmleStep1 = productSlug === 'usmle-step-1';

  const isFinra =
    isFinraSie ||
    isFinraSeries6 ||
    isFinraSeries7 ||
    isFinraSeries63 ||
    isFinraSeries65 ||
    isFinraSeries66;

  const showPracticeExams =
    !isAchievable && !isAmc8 && !isAmc10 && !isAmc12 && !isFinraSeries6 && !isUsmleStep1;

  return {
    isAchievable,
    isAmc8,
    isAmc10,
    isAmc12,
    isFinra,
    isFinraSeries6,
    isFinraSeries7,
    isFinraSeries63,
    isFinraSeries65,
    isFinraSeries66,
    isFinraSie,
    isUsmleStep1,
    showPracticeExams,
  };
};
